import React from "react"
import { Navigate } from "react-router-dom"
import { getLocalStorage } from "../../utils/localStorage";
export const  PrivateRoute = ({ children }) => {

    var data = getLocalStorage("user");
    
    return  data ? children : <Navigate to="../" />;
}